/** On a live run's page, after its version and period: "· 100 of 2,340 matched". */

import { traceCounts } from "../../detail/trace-run";
import type { ExperimentSummary } from "../../types";
import { pickedLine } from "./pull-text";

export function PinnedPullLine({ experiment: e }: { experiment: ExperimentSummary }) {
  const t = traceCounts(e);
  if (!t || !t.picked) return null;
  return <span>· {pickedLine(t.picked, t.matched)}</span>;
}
